function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(-319.000000, -742.000000) translate(0.000000, 726.000000) translate(287.000000, 0.000000) translate(32.000000, 16.000000)"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2B9D8B",
  stroke: "#2B9D8B",
  d: "M0 7l9-7 9 7v11c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V7z",
  transform: "translate(-319.000000, -742.000000) translate(0.000000, 726.000000) translate(287.000000, 0.000000) translate(32.000000, 16.000000) translate(3.000000, 2.000000)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#FFF",
  d: "M6 19L6 10 12 10 12 19",
  transform: "translate(-319.000000, -742.000000) translate(0.000000, 726.000000) translate(287.000000, 0.000000) translate(32.000000, 16.000000) translate(3.000000, 2.000000)"
})))))));

function SvgHomeActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home_active.384fba9d.svg";
export { ForwardRef as ReactComponent };